import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
var TextLineMirrorRegion = /** @class */ (function (_super) {
    __extends(TextLineMirrorRegion, _super);
    function TextLineMirrorRegion() {
        return _super.call(this) || this;
    }
    Object.defineProperty(TextLineMirrorRegion.prototype, "textLine", {
        // JS -> AS Bindings
        // AS -> JS Bindings
        // _textLine: flash.text.engine.TextLine;
        // _nextRegion: flash.text.engine.TextLineMirrorRegion;
        // _previousRegion: flash.text.engine.TextLineMirrorRegion;
        // _mirror: flash.events.EventDispatcher;
        // _element: flash.text.engine.ContentElement;
        // _bounds: flash.geom.Rectangle;
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/TextLineMirrorRegion', 'get textLine', '');
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLineMirrorRegion.prototype, "nextRegion", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/TextLineMirrorRegion', 'get nextRegion', '');
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLineMirrorRegion.prototype, "previousRegion", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/TextLineMirrorRegion', 'get previousRegion', '');
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLineMirrorRegion.prototype, "mirror", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/TextLineMirrorRegion', 'get mirror', '');
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLineMirrorRegion.prototype, "element", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/TextLineMirrorRegion', 'get element', '');
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLineMirrorRegion.prototype, "bounds", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/TextLineMirrorRegion', 'get textLine', '');
            return null;
        },
        enumerable: false,
        configurable: true
    });
    TextLineMirrorRegion.forceNativeConstructor = true;
    TextLineMirrorRegion.forceNativeMethods = true;
    return TextLineMirrorRegion;
}(ASObject));
export { TextLineMirrorRegion };
